// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// This file is used as a shim of "BlobDownloadResponse" for some bundlers
// when trying to bundle "BlobDownloadResponse"
// "BlobDownloadResponse" class is only available in Node.js runtime
export const BlobDownloadResponse = 1;
